export interface ITrainingEventDetailsResponse {

    ScheduleID: any;
    title: string;
    date: string;
    displaySoftware: any;
    end: string;
    hour: number;
    htmlContent: string;
    start: string;
    time: string;
    credits: string;
    IsExpired: boolean;
    url: string;

}


export class TrainingEventDetailsResponse implements ITrainingEventDetailsResponse {

    ScheduleID: any;
    title: string;
    date: string;
    displaySoftware: any;
    end: string;
    hour: number;
    htmlContent: string;
    start: string;
    time: string;
    credits: string;
    IsExpired: boolean;
    url: string;

}

